import React, { useState } from "react";
import {
  Box,
  Heading,
  Text,
  Button,
  Textarea,
  Flex,
  Avatar,
  Icon,
} from "@chakra-ui/react";
import { FaUserSecret, FaUser } from "react-icons/fa";
import dayjs from "dayjs";

const QnAScreen = ({ space, admin, member }) => {
  const [answer, setAnswer] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    setSubmitted(true);
  };

  return (
    <Flex
      direction="column"
      align="center"
      minH="100vh"
      bgGradient="linear(to-br, teal.600, white, teal.50)"
    >
      {/* Content area */}
      <Flex direction="column" align="center" flex="1" w="100%" p={4}>
        {/* Admin details centered at the top, stacked vertically */}
        <Box mb={6} textAlign="center">
          <Avatar
            name={admin?.name || admin?.alias || "Unknown User"}
            size="xl"
            bg="teal.500"
            color="white"
            mx="auto"
          />
          <Text mt={3} fontWeight="semibold" fontSize="xl" color="gray.800">
            {admin?.name || admin?.alias || "Unknown User"}
          </Text>
          <Text fontSize="sm" color="gray.500">
            {space.createdAt
              ? dayjs(space.createdAt).format("MMM D, YYYY h:mm A")
              : ""}
          </Text>
          <Text mt={3} fontWeight="semibold" fontSize="2xl" color="gray.800">
            {space?.title}
          </Text>
        </Box>

        <Box
          p={8}
          maxW="md"
          w="100%"
          bg="white"
          borderWidth="1px"
          borderRadius="lg"
          boxShadow="md"
          position="relative"
        >
          {/* Member name and user icon top right */}
          <Flex
            align="center"
            position="absolute"
            top={4}
            right={4}
            w="40%"
            justify="flex-end"
          >
            <Avatar
              name={member?.name || member?.alias || "You"}
              size="sm"
              bg="gray.400"
              color="white"
            />
            <Text
              ml={2}
              fontWeight="medium"
              fontSize="sm"
              color="gray.700"
              noOfLines={1}
            >
              {member?.name || member?.alias || "You"}
            </Text>
          </Flex>
          <Box h="32px" /> {/* Spacer for member row */}
          <Heading mb={4} size="md">
            Question
          </Heading>
          <Text mb={4} color="gray.600">
            {space.metaData?.question || "No question provided"}
          </Text>
          {!submitted ? (
            <>
              <Textarea
                placeholder="Type your answer..."
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                mb={4}
                rows={4}
              />
              <Button
                colorScheme="teal"
                onClick={handleSubmit}
                w="full"
                isDisabled={!answer.trim()}
              >
                Submit Answer
              </Button>
            </>
          ) : (
            <Text color="green.500" mt={4} textAlign="center">
              Thank you for your answer!
            </Text>
          )}
        </Box>

        {/* Admin info */}
        <Box mt={4} textAlign="center">
          <Text
            fontSize="sm"
            color="gray.600"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            Created by {admin?.name || admin?.alias || "Unknown User"}
            <Icon
              as={space.isIncognito ? FaUserSecret : FaUser}
              ml={2}
              title={space.isIncognito ? "Incognito" : "Admin"}
            />
          </Text>
          <Text fontSize="xs" color="gray.500">
            {space.createdAt
              ? dayjs(space.createdAt).format("MMM D, YYYY h:mm A")
              : ""}
          </Text>
        </Box>
      </Flex>

      {/* Footer - Always at bottom */}
      <Box w="100%" textAlign="center" py={4}>
        <Text fontSize="xs" color="gray.500" mb={2}>
          This content is neither created nor endorsed by Vartaverse
        </Text>
        <Text
          fontSize="lg"
          fontWeight="bold"
          color="teal.600"
          cursor="pointer"
          _hover={{
            color: "teal.700",
            textDecoration: "none",
          }}
          onClick={() => window.open(window.location.origin, "_blank")}
        >
          VartaVerse
        </Text>
      </Box>
    </Flex>
  );
};

export default QnAScreen;
